export const MANUAL_DISCOUNT = 'MANUAL_DISCOUNT';

export const MULTIPLE_VALUES = 'MULTIPLE_VALUES';
